export const project_types = [
    {
        "id": 1,
        "label": "Women's Empowerment",
        "value": "womens_empowerment"
    },
    {
        "id": 2,
        "label": "Water & Sanitation",
        "value": "water_sanitation"
    },
    {
        "id": 3,
        "label": "Sustainable Agriculture",
        "value": "sustainable_agriculture"
    },
    {
        "id": 4,
        "label": "Environment Sustainability",
        "value": "environment_sustainability"
    }
]
